<script>
import {useEvaluationSkillCandidateStore} from "@/stores/Evaluation/EvaluationSkillCandidate.js"
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {ref, watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";
import {useEvaluationInterviewStore} from "@/stores/Evaluation/EvaluationInterview";
import {storeToRefs} from "pinia";

export default {
    props: {},
    setup() {
        const {total, loading, filter, backgroundColor} = useSharedData();

        const {transformFilterValues} = useSharedMethod();
        const {formatedDate, formatedEvaluationCycle} = useSharedMethod();
        const {$i18n, $route} = useTools();

        const evaluationSkillCandidateStore = useEvaluationSkillCandidateStore();
        const securityStore = useSecurityStore();

        filter.value = {archive: false};

        const dynamicStepHeaders = ref([]);
        const headers = ref([]);

        function findAll() {
            loading.value = true;
            filter.value.skillId = skillId.value;

            headers.value = [];
            dynamicStepHeaders.value = [];

            addHeaderHead();
            axios.get('/evaluationSkillCandidates', {params: transformFilterValues(filter.value)}).then((response) => {
                evaluationSkillCandidateStore.setEvaluationSkillCandidates(formatData(response.data));
                total.value = evaluationSkillCandidateStore.evaluationSkillCandidates.length;

                evaluationSkillCandidateStore.evaluationSkillCandidates.forEach(element => {
                    element.steps.forEach(step => {
                        element[step.stepPhaseName] = step;
                        addHeader(step);
                    });
                });
                dynamicStepHeaders.value.sort((a, b) => a.ordre - b.ordre);
                headers.value.push(...dynamicStepHeaders.value);
                addFooterHeader();
            }).finally(() => {
                loading.value = false;
            });
        }

        function addHeaderHead() {
            headers.value.push(
                {
                    text: $i18n.t("module.worker"),
                    align: "left",
                    sortable: true,
                    value: "workerName",
                    width: "0%",
                    groupable: true,
                },
            );
        }

        function addHeader(step) {
            if (!dynamicStepHeaders.value.some((header) => header.text === step.stepPhaseName)) {
                dynamicStepHeaders.value.push({
                    text: step.stepPhaseName,
                    align: "center",
                    sortable: false,
                    value: step.stepPhaseName,
                    ordre: step.stepOrder + 1,
                });
            }
        }

        function addFooterHeader() {
            headers.value.push(
                {
                    text: $i18n.t('evaluation.score'),
                    align: "left",
                    sortable: true,
                    value: "note",
                    groupable: false,
                },
            );
        }

        function formatData(data) {
            const grouped = data.reduce((acc, item) => {
                if (!acc[item.workerId]) {
                    acc[item.workerId] = [];
                }
                acc[item.workerId].push(item);
                return acc;
            }, {});
            // Map to desired structure
            return Object.entries(grouped).map(([workerId, items]) => {
                // Find the item with max stepOrder
                const lastStep = items.reduce((max, item) =>
                    item.stepOrder > max.stepOrder ? item : max
                );

                return {
                    workerId: parseInt(workerId),
                    workerName: items[0].workerName,
                    note: lastStep.interviewNote,
                    steps: items.map(item => ({
                        id: item.id,
                        stepId: item.stepId,
                        stepPhaseName: item.stepPhaseName,
                        stepOrder: item.stepOrder,
                        interviewId: item.interviewId,
                        interviewNote: item.interviewNote,
                        done: item.done,
                        tolerated: item.tolerated,
                        stepLaunched: item.stepLaunched,
                        stepDone: item.stepDone,
                        stepCurrent: item.stepCurrent,
                        interviewClosed: item.interviewClosed
                    }))
                };
            });
        }

        const skill = ref({});
        const skillId = ref($route.params.skillId);
        const loadingSkill = ref(false);

        function findSkillById() {
            if (skillId.value !== null && skillId.value !== undefined) {
                loadingSkill.value = true;
                axios.get(`/evaluationSkills/${skillId.value}`).then((response) => {
                    skill.value = response.data;
                }).finally(() => {
                    loadingSkill.value = false;
                });
            }
        }

        const evaluationInterviewStore = useEvaluationInterviewStore();
        const {refresh} = storeToRefs(evaluationInterviewStore);

        watch(() => refresh.value, () => {
            findAll();
            findSkillById();
        });

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true});

        watch(() => skillId.value, () => {
            findAll();
            findSkillById();
            getProposalCatalogs();
        }, {immediate: $route.params.skillId});

        function formatedState(item) {
            if (item.tolerated) {
                return $i18n.t('evaluation.tolerated');
            } else if (item.done) {
                return `${$i18n.t('common.validated')} (${item.interviewNote})`;
            } else if (item.stepCurrent) {
                return `${$i18n.t('common.ACTION_STATE_WAITING')} (${item.interviewNote})`;
            } else {
                return $i18n.t('common.ACTION_STATE_IN_PROGRESS');
            }
        }

        const proposalCatalogHeader = [
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "workerCode",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("module.worker"),
                align: "left",
                value: "workerName",
                sortable: true,
                groupable: true,
                width: "0%"
            },
            {
                text: $i18n.t("training.department"),
                align: "start",
                sortable: true,
                value: "workerOrganizationalChartName",
                width: "0%",
                groupable: true,
            },
            {
                text: $i18n.t("training.theme"),
                align: "start",
                sortable: true,
                value: "catalogName",
                groupable: true,
            },
        ];
        const proposalCatalogs = ref([]);
        const loadingProposalCatalogs = ref(false);

        function getProposalCatalogs() {
            if (skillId.value !== null && skillId.value !== undefined) {
                axios.get(`/evaluationSkills/getProposalCatalogs/${skillId.value}`).then((response) => {
                    proposalCatalogs.value = response.data;
                    console.log(proposalCatalogs.value);
                }).finally(() => {
                    loadingProposalCatalogs.value = false;
                })
            }
        }

        return {
            evaluationSkillCandidateStore,
            securityStore,
            loadingSkill,
            skillId,
            skill,
            headers,
            dynamicStepHeaders,
            total,
            loading,
            filter,
            backgroundColor,
            proposalCatalogs,
            loadingProposalCatalogs,
            proposalCatalogHeader,
            findAll,
            formatedDate,
            formatedState,
            formatedEvaluationCycle,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.evaluation_skill_candidates')"
            :total="total"
            show-filter
            :filter="filter"
        >
            <template #filter>
                <v-row dense>
                    <v-col cols="12">
                        <str-worker-autocomplete
                            v-model="filter.workerId"
                            :label="$t('module.worker')"
                        />
                    </v-col>
                    <v-col cols="12">
                        <str-evaluation-file-autocomplete
                            v-model="filter.fileId"
                            :label="$t('module.evaluation_skill_files')"
                            type="EVALUATION_SKILL"
                        />
                    </v-col>
                </v-row>
            </template>
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="3">
                            <str-skill-autocomplete
                                v-model="skillId"
                                :label="$t('evaluation.companion')"
                                :select-max="!$route.params.skillId"
                                not-clearable
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <v-row dense>
                    <v-col cols="3">
                        <v-skeleton-loader
                            v-show="loadingSkill"
                            ref="skeleton"
                            :type="'table'"
                            class="mx-auto"
                        ></v-skeleton-loader>
                        <v-simple-table
                            v-if="skill && !loadingSkill"
                            class="elevation-5"
                            height="600"
                        >
                            <template v-slot:default>
                                <tbody>
                                <tr>
                                    <th class="text-right">{{ $t('common.code') }}</th>
                                    <td class="text-left">
                                        <w-chip :text="skill.code"/>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="text-right">{{ $t('common.label') }}</th>
                                    <td class="text-left">{{ skill.name }}</td>
                                </tr>
                                <tr>
                                    <th class="text-right">{{ $t('common.start') }}</th>
                                    <td class="text-left">
                                        <w-inline-text outlined :text="formatedDate(skill.cycleStart)"/>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="text-right">{{ $t('common.end') }}</th>
                                    <td class="text-left">
                                        <w-chip color="teal" :text="formatedDate(skill.cycleEnd)"/>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="text-right">Période</th>
                                    <td class="text-left">
                                        <w-inline-text :text="formatedEvaluationCycle(skill)"/>
                                    </td>
                                </tr>
                                <tr
                                    v-for="step in skill.steps"
                                    :key="step.id"
                                >
                                    <th class="text-right">{{ step.phaseName }}</th>
                                    <td class="text-left">
                                        <w-chip
                                            outlined
                                            :text="`${step.completedNumber + step.toleratedNumber}/${step.concernedNumber}`"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">{{ $t('common.percent') }}</td>
                                    <td class="text-left">
                                        <v-progress-linear
                                            :value="((skill.completedNumber + skill.toleratedNumber) * 100.0)/skill.concernedNumber"
                                            color="teal lighten-2"
                                            buffer-value="0"
                                            stream
                                            height="25"
                                        >
                                            <strong>
                                                {{(((skill.completedNumber + skill.toleratedNumber) * 100.0) / skill.concernedNumber).toFixed(2) }}%
                                            </strong>
                                        </v-progress-linear>
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="9">
                        <v-tabs
                            class="tabs"
                            color="teal"
                            :background-color="backgroundColor"
                        >
                            <v-tab>
                                {{ $t('evaluation.evaluations_monitoring') }}
                            </v-tab>
                            <v-tab>
                                {{ $t('evaluation.proposed_theme') }}
                            </v-tab>

                            <v-tab-item>
                                <w-data-table
                                    :headers="headers"
                                    :items="evaluationSkillCandidateStore.evaluationSkillCandidates"
                                    :total="total"
                                    identity="workerId"
                                    :loading="loading"
                                    disable-pagination
                                    fixed-header
                                    height="600"
                                    descending
                                >
                                    <template v-slot:[`item.workerName`]="{ item }">
                                        <w-inline-text bold :text="item.workerName"/>
                                    </template>

                                    <!-- Dynamic slot for step headers -->
                                    <template
                                        v-for="header in dynamicStepHeaders"
                                        v-slot:[`item.${header.value}`]="{ item }"
                                    >
                                        <w-inline-text
                                            :key="header.value"
                                            :text="formatedState(item[header.value])"
                                        />
                                        <w-btn-icon
                                            :key="`evaluate-${header.value}`"
                                            :disabled="!item[header.value].stepLaunched"
                                            color="blue darken-2"
                                            icon="mdi-clipboard-text-clock"
                                            :tooltip="$t('evaluation.evaluate')"
                                            @press="$router.push({name: 'evaluation_skill_candidates.interviews.edit', params: {id: item[header.value].interviewId}})"
                                        />
                                        <!--<w-btn-icon
                                            :key="`tolerate-${header.value}`"
                                            :disabled="item[header.value].done || item[header.value].tolerated || !item[header.value].stepLaunched"
                                            color="purple"
                                            icon="mdi-clock-end"
                                            :tooltip="$t('evaluation.tolerate')"
                                            @press="$router.push({name: 'evaluation_skill_candidates.tolerate', params: {id: item[header.value].id}})"
                                        />-->
                                    </template>
                                    <template v-slot:[`item.note`]="{ item }">
                                        <w-chip color="teal" :text="item.note"/>
                                    </template>
                                </w-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <w-data-table
                                    :headers="proposalCatalogHeader"
                                    :items="proposalCatalogs"
                                    :loading="loadingProposalCatalogs"
                                    sort-by="catalogName"
                                    disable-pagination
                                    show-group-by
                                    group-by="catalogName"

                                >
                                    <template v-slot:group-header="{ group, groupBy, isOpen, toggle }">
                                        <td colspan="3">
                                            <v-btn icon @click="toggle" v-if="isOpen">
                                                <v-icon>mdi-minus</v-icon>
                                            </v-btn>
                                            <v-btn icon @click="toggle" v-else>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            <span v-if="groupBy[0] === 'catalogName'">
                                              {{ $t("training.theme") }}: <w-inline-text bold :text="group"/>
                                            </span>
                                            <span v-if="groupBy[0] === 'workerOrganizationalChartName'">
                                                {{ $t("training.department") }}: <w-inline-text bold :text="group"/>
                                            </span>
                                            <span v-if="groupBy[0] === 'workerName'">
                                                {{ $t("recruitment_request.applicant") }}: <w-inline-text bold :text="group"/>
                                            </span>
                                        </td>
                                    </template>
                                    <template v-slot:[`item.workerCode`]="{ item }">
                                        <w-chip :text="item.workerCode"/>
                                    </template>
                                    <template v-slot:[`item.workerOrganizationalChartName`]="{ item }">
                                        <w-inline-text :text="item.workerOrganizationalChartName"/>
                                    </template>
                                    <template v-slot:[`item.workerName`]="{ item }">
                                        <w-inline-text :text="item.workerName"/>
                                    </template>
                                    <template v-slot:[`item.catalogName`]="{ item }">
                                        <w-inline-text :text="item.catalogName"/>
                                    </template>
                                </w-data-table>
                            </v-tab-item>
                        </v-tabs>
                    </v-col>
                </v-row>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
